module.exports = __webpack_public_path__ + "static/media/ew-logo-2020-white.afc0a959.svg";